import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertLevel, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";

export class ActuatorNotTurning extends AlertLogic {
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.EQUIPMENT_FAILURE ];
    static title = Locale.gettext('Actuator not turning');
    static type:AlertType|AlertType[] = AlertType.ActuatorNotTurning;

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;

        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);
        
        const detailDescription4 = 
            config?.Config?.Settings?.IgnoreActuatorErrorsAndTurnOnPumps
            ? undefined
            : this.locale.gettext('Pumps will not run until this is addressed.')
        ;
        const detailDescription5 = 
            config?.Config?.FreezeProtect.Mode !== Config.FreezeProtectModes.DISABLED
            ? this.locale.gettext('Please note that this alert is ignored when Freeze Protect is running.')
            : undefined
        ;

        // Varying across alert types
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Malfunctioning Actuator'),
            cardDescription: this.locale.gettext('%1$s is not turning', device.Name),
            cardIllustration: 'pipes_emergency',
            detailIcon: 'actuator3',
            detailDescription: this.locale.gettext('We detected actuator "%3$s" on port %1$s has stopped responding %2$s.',
                device.HardwareDevice.Ports[0]?.Number || this.locale.gettext('Unknown'),
                this.locale.formatTimeHumanFriendy(alert.created, undefined, undefined, true, timeZone),
                device.Name
            ),
            detailDescription2: this.locale.gettext('Please check that it is correctly wired, connected, and that the motor is working.'),
            detailDescription3: this.locale.gettext("If all of the actuators are not working, please check The Attendant's power fuse!"),
            detailDescription4,
            detailDescription5,
            actionButtonTitle: false,
            actionButtonAction: false,
            resolveSummary: this.locale.gettext('%1$s is back to normal', device.Name)
        });
        alertInfo.contentCategories = ActuatorNotTurning.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device:Partial<Config.DeviceConfig> = config?.Config?.Devices.find(dev => dev.DeviceType === "ActuatorThreeWay") || 
                        config?.Config?.Devices.find(dev => dev.DeviceType === "ActuatorTwoWay");
        device = device;
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type.toString().replace('ACTUATOR_', '')),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            bodyUuid: config?.Config?.BodiesOfWater[0]?.UUID,
            level: AlertLevel.Error,
            type: type,
            data: {
                
            }
        }) : null;
    }
}